import { render, staticRenderFns } from "./StepIndicator.vue?vue&type=template&id=13bd3d70&scoped=true&"
import script from "./StepIndicator.vue?vue&type=script&lang=js&"
export * from "./StepIndicator.vue?vue&type=script&lang=js&"
import style0 from "./StepIndicator.vue?vue&type=style&index=0&id=13bd3d70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bd3d70",
  null
  
)

export default component.exports